import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import * as moment from 'moment';
import { environment } from 'environments/environment';
import * as _ from 'lodash';

@Component({
  selector: 'app-package-preview',
  templateUrl: './package-preview.component.html',
  styleUrls: ['./package-preview.component.css']
})
export class PackagePreviewComponent implements OnInit {
  eventName: string;
  seasonPreview: any;
  loading: boolean;
  imageURL = environment.URL_TEAM_IMAGES;
  teamDescription: any;
  teamName: any;
  teamImage: any;
  vendorId: any;

  events;

  constructor(
    public dialogRef: MatDialogRef<PackagePreviewComponent>,
    private inventoryService: SsInventoryService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    // this.eventName = data.eventName;
    // this.teamImage = data.teamImage;
    // this.teamName = data.teamName;
    // this.teamDescription = data.teamDescription;
    this.buildDraft(data.events); 
  }

  buildDraft(events){
    _.each(events, (value) => {
      if (value.event_time === '00:00' || value.event_time === 'TBA' || value.event_time === 'TBD') {
        // Display TDB if invalid date
        value.event_time = 'TBD';
      } else {
        value.event_time = moment(value.event_time, 'hh:mm').format('LT');
      }
    });
    this.events = events; 
  }

  ngOnInit() {
   
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/package-preview/package-preview.component.ts